import logo from './brand/harmovi-logo.svg'
import logoReverse from './brand/harmovi-logo-reverse.svg'
import mark from './brand/harmovi-mark.svg'
import logoTest from './brand/harmovi-logo-test.svg'
import logoReverseTest from './brand/harmovi-logo-reverse-test.svg'
import markTest from './brand/harmovi-mark-test.svg'
import { STAGING } from '../staging'

// The Harmovi logo, "Balance" (docs/13-brand.md). The files come from
// brand/build.py; never redraw or recolour them here. Staging shows the
// copies labelled TEST.
const FILES = STAGING
  ? {
      logo: { src: logoTest, ratio: 226.53 / 27.2 },
      reverse: { src: logoReverseTest, ratio: 226.53 / 27.2 },
      mark: { src: markTest, ratio: 37.2 / 25.6 },
    }
  : {
      logo: { src: logo, ratio: 162.25 / 27.2 },
      reverse: { src: logoReverse, ratio: 162.25 / 27.2 },
      mark: { src: mark, ratio: 37.2 / 25.2 },
    }

export default function Logo({ variant = 'logo', height = 24, className, decorative = false, adaptive = false }: {
  variant?: keyof typeof FILES
  height?: number
  className?: string
  // Beside the word "Harmovi" already, the logo needs no name of its own.
  decorative?: boolean
  // On a page that follows the reader's dark setting (the booking site),
  // switch to the reverse logo in dark mode.
  adaptive?: boolean
}) {
  const f = FILES[variant]
  const img = (
    <img
      className={adaptive ? undefined : className}
      src={f.src}
      alt={decorative ? '' : 'Harmovi'}
      height={height}
      width={Math.round(height * f.ratio)}
      draggable={false}
    />
  )
  if (!adaptive) return img
  return (
    <picture className={className}>
      <source srcSet={FILES.reverse.src} media="(prefers-color-scheme: dark)" />
      {img}
    </picture>
  )
}
